import React, { useEffect, useState } from 'react'
import PurchaseOrderDashboard from './PurchaseOrderDashboard';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { fetchPurchaseOrdersDashboardFilters } from '../../../containers/actions/common/purchaseOrderAction';
import usePrevious from '../../helpers/previousProps';

const PurchaseOrderTabs = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [savedFilter, setSavedFilter] = useState({});

  const purchaseOrderFilter = useSelector((state) =>
      state.pcmp.common?.purchaseOrder?.purchaseOrderDetailsFilters?.status
        ? state.pcmp.common?.purchaseOrder?.purchaseOrderDetailsFilters
        : {}
  );

  useEffect(() => {
    // BCM-737: a "View PO" email deep link (?poNumber=...) is meant to show
    // that one PO undisturbed. Loading the user's saved dashboard filters
    // here would update `savedFilter` below, which the fetch effect in
    // PurchaseOrderDashboard.jsx depends on - re-triggering it a moment
    // later with the saved (broader) filters and clobbering the deep-linked
    // single-PO view. Skip loading saved filters for this one mount when a
    // deep link is active; the user's saved filters still apply on every
    // other visit.
    const hasDeepLinkPoNumber = new URLSearchParams(location.search).get("poNumber");
    if (hasDeepLinkPoNumber) return;
    dispatch(fetchPurchaseOrdersDashboardFilters());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])

  let previousPurchaseOrderFilter = usePrevious(purchaseOrderFilter)

  
  useEffect(() => {
      if (
        JSON.stringify(purchaseOrderFilter) !==
        JSON.stringify(previousPurchaseOrderFilter)
      ) {
        const savedFilterData = purchaseOrderFilter?.save_filter_options && typeof purchaseOrderFilter?.save_filter_options === "object" ? purchaseOrderFilter?.save_filter_options : {};
        setSavedFilter(savedFilterData);            
          
      }
  }, [previousPurchaseOrderFilter, purchaseOrderFilter]);
  

  return <PurchaseOrderDashboard savedFilter={savedFilter} />
}

export default PurchaseOrderTabs